var CODE128_AUTO = {};
export {
  CODE128_AUTO as __exports
};
//# sourceMappingURL=index201.js.map
